import { createAppReducer } from 'lib/redux/reducerUtils'
import {
  BEGIN_POST_LOGIN_OPTIMIZELY_SYNC,
  END_POST_LOGIN_OPTIMIZELY_SYNC,
  SET_OPTIMIZELY_EXPERIMENTS,
  SET_OPTIMIZELY_FEATURE_FLAGS,
} from 'actions/actionConstants'

export const initialOptimizelyState: App.OptimizelyState = {
  optimizelyExperiments: {},
  optimizelyFeatureFlags: {},
  isPostLoginOptimizelySyncing: false,
}

export default createAppReducer<App.OptimizelyState>(initialOptimizelyState, {
  // Bulk experiments update - handles both single and multiple updates
  [SET_OPTIMIZELY_EXPERIMENTS]: (state, action) => ({
    optimizelyExperiments: {
      ...state.optimizelyExperiments,
      ...Object.fromEntries(
        Object.keys(action.experiments).map(flagKey => [
          flagKey,
          { ...state.optimizelyExperiments?.[flagKey], ...action.experiments[flagKey] } as App.OptimizelyExperimentDetails,
        ]),
      ),
    },
  }),
  // Bulk feature flags update - handles both single and multiple updates
  [SET_OPTIMIZELY_FEATURE_FLAGS]: (state, action) => ({
    optimizelyFeatureFlags: {
      ...state.optimizelyFeatureFlags,
      ...action.flags,
    },
  }),
  [BEGIN_POST_LOGIN_OPTIMIZELY_SYNC]: () => ({
    isPostLoginOptimizelySyncing: true,
  }),
  [END_POST_LOGIN_OPTIMIZELY_SYNC]: () => ({
    isPostLoginOptimizelySyncing: false,
  }),
})
